import { useState, useEffect } from 'react';
import { FormState } from '../AgentArrivalHypothesisModal/AgentArrivalForm';

export const useFormState = (
    initialState: FormState,
): [FormState, React.Dispatch<React.SetStateAction<FormState>>] => {
    const [state, setState] = useState(initialState);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        if (
            state.selectedOrgChartHrSoftwareId &&
            state.selectedStartDate &&
            !Number.isNaN(new Date(state.selectedStartDate).getTime()) &&
            state.agentETP &&
            state.retirementSystem &&
            state.mantyStatus &&
            state.officialGrade &&
            Number(state.echelon) > 0
        )
            setIsFormValid(true);
    }, [
        state.selectedOrgChartHrSoftwareId,
        state.selectedStartDate,
        state.selectedEndDate,
        state.agentETP,
        state.retirementSystem,
        state.mantyStatus,
        state.officialGrade,
        state.echelon,
    ]);

    return [{ ...state, isFormValid }, setState];
};
